module.exports = __webpack_public_path__ + "static/img/newBg.a9913a75.png";